import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { InputConfig } from '../../entities/input-config';
import {CommonService} from '../../services/common/common.service';

@Component({
  selector: 'app-s-input',
  templateUrl: './s-input.component.html',
  styleUrls: ['./s-input.component.less']
})
export class SInputComponent implements OnInit {
  @Input() inputObj: InputConfig;
  @Output() inputChange: EventEmitter<any> =  new EventEmitter();

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.initAtrr();
  }

  initAtrr() {
    this.inputObj.disabled = this.commonService.isNull(this.inputObj.disabled) ? this.inputObj.disabled : false;
  }

  modelChange(e: any) {
    this.inputChange.emit(e);
  }
}
